import Butter from 'buttercms';

const butter = Butter('c7ed2d2c104b3cdd82cc05607e4506ae9a09e148');

export default butter;
